import { ApiError, http } from '@/services/api/client';
import type {
  CreateProjectReportCommentPayload,
  CreateProjectReportPayload,
  ProjectReportComment,
  ProjectReportPageResult,
  ProjectReportRecord,
  QueryProjectReportsParams,
  UpdateProjectReportPayload,
} from '@/types/project-report';

export async function fetchProjectReports(
  params: QueryProjectReportsParams,
): Promise<ProjectReportPageResult> {
  return http.get('/project-reports', { params }) as Promise<ProjectReportPageResult>;
}

export async function fetchProjectReportsByProject(
  projectId: string,
  params: Omit<QueryProjectReportsParams, 'projectId'> = {},
): Promise<ProjectReportPageResult> {
  return http.get(`/projects/${projectId}/reports`, { params }) as Promise<ProjectReportPageResult>;
}

export async function fetchProjectReport(id: string): Promise<ProjectReportRecord> {
  return http.get(`/project-reports/${id}`) as Promise<ProjectReportRecord>;
}

export async function createProjectReport(
  payload: CreateProjectReportPayload,
): Promise<ProjectReportRecord> {
  return http.post('/project-reports', payload) as Promise<ProjectReportRecord>;
}

export async function updateProjectReport(
  id: string,
  payload: UpdateProjectReportPayload,
): Promise<ProjectReportRecord> {
  return http.patch(`/project-reports/${id}`, payload) as Promise<ProjectReportRecord>;
}

export async function deleteProjectReport(id: string): Promise<{ id: string }> {
  return http.delete(`/project-reports/${id}`) as Promise<{ id: string }>;
}

/** T6.1-A：404 表示已不存在，视为删除成功 */
export function isProjectReportAlreadyDeletedError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}

export async function deleteProjectReportOrGone(id: string): Promise<void> {
  try {
    await deleteProjectReport(id);
  } catch (error) {
    if (isProjectReportAlreadyDeletedError(error)) {
      return;
    }
    throw error;
  }
}

export async function fetchProjectReportComments(
  projectReportId: string,
): Promise<ProjectReportComment[]> {
  return http.get(`/project-reports/${projectReportId}/comments`) as Promise<ProjectReportComment[]>;
}

export async function createProjectReportComment(
  projectReportId: string,
  payload: CreateProjectReportCommentPayload,
): Promise<ProjectReportComment> {
  return http.post(`/project-reports/${projectReportId}/comments`, payload) as Promise<ProjectReportComment>;
}
